<div class="wrapper">
  <div class="assistant-sub-header">
    {{ botBehaviorContent.header }}
  </div>
  <div class="default-mode-container">
    <div class="configuration-container">
      <div class="configuration-title">{{ botBehaviorContent.botActivation }}</div>
      <u-dropdown
        [options]="botBehaviorContent.optionsBotSensitivity"
        [showItemIconSelect]="true"
        optionLabel="label"
        optionalSubLabel="subLabel"
        dropdownSize="medium"
        (onChange)="onSensitiveDropDownChanged($event)"
        [styles]="DROPDOWN_STYLE"
        [disabled]="disabled()"
        [itemIconStyle]="ITEM_ICON_STYLE"
        [selectedItemIconStyle]="ITEM_ICON_STYLE"
        [appendTo]="'body'"
        [selectedValueString]="assistant()?.settings?.instructions?.sensitivity"
      >
      </u-dropdown>
    </div>
    <div class="configuration-container space-bottom">
      <div class="configuration-title">{{ botBehaviorContent.activateBotMessages }}</div>
      <u-toggle-switch
        [checked]="assistant()?.settings?.replyBotMessages"
        (onChange)="onToggleActiveBotMessages($event)"
        [disabled]="disabled()"
        debounceClick
        type="small"
      >
      </u-toggle-switch>
    </div>
    <div>
      <div class="configuration-title space-bottom">
        {{ botBehaviorContent.excludedDomains
        }}<u-icon
          [model]="{ type: 'font', value: 'icon-info' }"
          [styles]="{ color: 'var(--color-primary)', fontSize: '14px' }"
          [pTooltip]="botBehaviorContent.excludedDomainsTooltip"
          tooltipPosition="bottom"
          tooltipStyleClass="u-tooltip"
        ></u-icon>
      </div>
      <u-chips
        class="border-bottom"
        [showClear]="true"
        [style]="CHIPS_STYLE"
        [validationRegex]="chipsValidationRegex"
        (itemsChanged)="excludeDomainsChanged($event)"
        [items]="excludesDomains()"
        [disabled]="disabled()"
        [placeholder]="botBehaviorContent.excludeDomainsPlaceholder"
        [emitOnInput]="true"
        [focusInputAuto]="false"
        #chips
      ></u-chips>
      @if (hasDomainError()) {
        <div class="error-message">
          {{ botBehaviorContent.excludeDomainsError }}
        </div>
      }
    </div>
  </div>
</div>
